import { render, staticRenderFns } from "./new-case.vue?vue&type=template&id=389aea9e&scoped=true"
import script from "./new-case.vue?vue&type=script&lang=js"
export * from "./new-case.vue?vue&type=script&lang=js"
import style0 from "./new-case.vue?vue&type=style&index=0&id=389aea9e&prod&lang=scss&scoped=true"
import style1 from "./new-case.vue?vue&type=style&index=1&id=389aea9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389aea9e",
  null
  
)

export default component.exports